import { render, staticRenderFns } from "./FlowConfiguration.vue?vue&type=template&id=1f8b413f&"
import script from "./FlowConfiguration.vue?vue&type=script&lang=js&"
export * from "./FlowConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports